import { Utilities as utilities } from '@truckdown/framework';
import { AppType } from './AppType';

export class SystemInfoModel {
    constructor(json?: any) {
        if (json) {
            this.id = utilities.json.getStringValue(json, '_id', '');
            this.environment = utilities.json.getStringValue(json, 'env', '');
            this.date = utilities.json.getDateValue(json, 'dt', new Date(0));
            this.heartBeat = utilities.json.getDateValue(json, 'hb', new Date(0));
            this.name = utilities.json.getStringValue(json, 'n', '');
            this.processorCount = utilities.json.getNumberValue(json, 'pc', 0);
            this.platform = utilities.json.getStringValue(json, 'p', '');
            this.platformVersion = utilities.json.getStringValue(json, 'pv', '');
            this.title = utilities.json.getStringValue(json, 'title', '');

            this.type = utilities.json.getEnumValue<AppType>(json, 't', AppType, AppType.Unknown);

            this.product = utilities.json.getStringValue(json, 'prod', '');
            this.version = utilities.json.getStringValue(json, 'v', '');
            this.assemblyVersion = utilities.json.getStringValue(json, 'av', '');
            this.description = utilities.json.getStringValue(json, 'desc', '');
            this.company = utilities.json.getStringValue(json, 'comp', '');
            this.copyright = utilities.json.getStringValue(json, 'copy', '');
            this.framework = utilities.json.getStringValue(json, 'frame', '');
            this.config = utilities.json.getStringValue(json, 'conf', '');

            this.references = utilities.json.getArrayValue(json, (dt) => {
                if (utilities.data.isString(dt)) {
                    return dt;
                }
                return null;
            }, 'ref', []);
        }
    }

    id: string = '';
    environment: string = '';
    date: Date = new Date(0);
    heartBeat: Date = new Date(0);
    name: string = '';
    processorCount: number = 0;
    platform: string = '';
    platformVersion: string = '';
    title: string = '';
    type: AppType = AppType.Unknown;
    product: string = '';
    version: string = '';
    assemblyVersion: string = '';
    description: string = '';
    company: string = '';
    copyright: string = '';
    framework: string = '';
    config: string = '';
    references: string[] = [];
}